import React from 'react';
import { useSubmitStatus } from '../../contexts/submit-status-context';
import { FadeOut } from './fade-out';
import { SubmitErrorMessage } from './submit-error-message';
import { SubmitThankYouMessage } from './submit-thank-you-message';
export const SubmitStatusMessage = () => {
    const { submitSuccessMessage, submitFailureCode, submitFailureMessage } = useSubmitStatus();
    return (React.createElement("div", { role: "region", "aria-live": "polite" },
        React.createElement(FadeOut, { visible: !!submitSuccessMessage },
            React.createElement(SubmitThankYouMessage, { messageText: submitSuccessMessage })),
        React.createElement(SubmitErrorMessage, { errorMessageCode: submitFailureCode, errorMessage: submitFailureMessage })));
};
//# sourceMappingURL=submit-status-message.js.map